export const LONG_DURATION = 2000;
export const SHORT_DURATION = 1000;
export const NO_DURATION = 0;
export const DELAY = 500;
export const NO_DELAY = 0;
export const SCENES = ['scene', 'dummyScene']
export const MODEL_URL = "https://d1sonmy4sf0d9y.cloudfront.net/3dmodel/6-a67ed189c9c749e1960b96cef0bb7f8e/model.glb";
export const DEV_SERVER_URL = 'http://0.0.0.0:4040/'
export const TEST_SOURCE_FILE_NAME = 'test-content.json'
export const THRESHOLD = 0.05;
